import type { Story } from "../types";
import echoesOfEden9 from "./echoes-of-eden-9.json";
import "../components/Scene.css";

export const story: Story = echoesOfEden9 as Story;
